export class RemoteConfig {
    constructor(payload, experiment, source) {
        this.payload = payload;
        this.experiment = experiment;
        this.source = source;
    }
}
//# sourceMappingURL=RemoteConfig.js.map